import moment from "moment";
import { useState } from "react";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { getProfileData } from "../api/fetchers/profile-fetcher";
import Loader from "../collections/shared/Loader/Loader";
import cn from "clsx";
import { twMerge } from "tailwind-merge";
import axios from "../axios";
import { login } from "../slices/userSlice";

const ProfilePage = () => {
  const { user, access_token } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isDisbled, setIsDisbled] = useState(true);
  const [nameInput, setNameInput] = useState("");
  const [phoneInput, setPhoneInput] = useState("");
  const [focusedInput,setFocusedInput] = useState("")
  const [count, setCount] = useState();
  const [isShow, setIsShow] = useState(false);
  const { data, isError, isLoading } = useQuery(
    ["get-profile"],
    () => getProfileData(user.id),
    {
      onSuccess: (data) => {
        setNameInput(data.name);
        setPhoneInput(data.contact)
        setCount(
          data.profileUpdationCount.limit - data.profileUpdationCount.name
        );
      },
    }
  );
  const handlePhoneInputChange = (e) =>{
    const inputVal = e.target.value;
    setPhoneInput(inputVal);
    setIsDisbled(inputVal.length!== 10)
  }
  const submitForm = () => {
    axios
      .patch(
        "user/profile",
        {
          name: nameInput,
          id: user.id,
          contact: phoneInput,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: access_token,
          },
        }
      )
      .then(() => {
        dispatch(
          login({
            user: { ...user, name: nameInput, contact: phoneInput},
            access_token: access_token,
            has_name: true,
            has_phone: true,
          })
        );
        setIsDisbled(true);
        setCount((count) => count - 1);
      })
      .catch(() => {
        setNameInput(data.name);
        setPhoneInput(data.contact)
        setCount(
          data.profileUpdationCount.limit - data.profileUpdationCount.name
        );
      });
  };
  return (
    <div className="grid gap-10 w-full place-items-center h-[calc(100vh-75px)] absolute top-[75px]">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="p-10 w-1/2">
          <div className="px-4 py-10 bg-gray-50 shadow-md w-full h-[500px]">
            <h4 className="mb-8 text-gray-500 flex gap-2 items-center">
              <i className="fa-solid fa-user"></i> Profile Information
            </h4>
            <p
              className={twMerge(
                cn(
                  "text-gray-500 font-normal text-sm text-center mb-1 opacity-0",
                  {
                    "opacity-1": isShow && focusedInput === "name"
                  }
                )
              )}
            >
              You can edit your name up to {count} times in a year
              <span className="text-red-400">*</span>
            </p>

            <div class="mb-3 flex justify-between  items-center gap-2">
              <label
                for="base-input"
                className="block text-base font-medium text-gray-600 dark:text-white"
              >
                Name:
              </label>
              <div className="flex gap-1 items-center w-[80%]">
                <input
                  onFocus={() => {
                    setIsShow(true);
                    setFocusedInput("name")
                  }}
                  onBlur={() => setIsShow(false)}
                  defaultValue={data?.name}
                  value={nameInput}
                  onChange={(e) => {
                    setNameInput(e.target.value);
                    setIsDisbled(false);
                  }}
                  type="text"
                  id="base-input"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[80%] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                <button
                  onClick={submitForm}
                  disabled={isDisbled}
                  className={twMerge(
                    cn("cursor-not-allowed", {
                      "cursor-pointer": !isDisbled && nameInput !== data.name,
                    })
                  )}
                >
                  <i class="fa-solid fa-check bg-primary text-lg text-white px-2 py-1 rounded"></i>
                </button>
              </div>
            </div>
            <div class="mb-3 flex justify-between  items-center gap-2">
              <label
                for="base-input"
                className="block text-base font-medium text-gray-600 dark:text-white"
              >
                Phone Number:
              </label>
              <div className="flex gap-1 items-center w-[80%]">
                <input
                  onFocus={() => {
                    setIsShow(true);
                    setFocusedInput("phone");
                  }}
                  onBlur={() => setIsShow(false)}
                  defaultValue={data?.contact}
                  value={phoneInput}
                  onChange={handlePhoneInputChange
                  }
                  type="number"
                  id="base-input"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[80%] p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                <button
                  onClick={submitForm}
                  disabled={isDisbled}
                  className={twMerge(
                    cn("cursor-not-allowed", {
                      "cursor-pointer": !isDisbled && phoneInput !== data.contact,
                    })
                  )}
                >
                  <i class="fa-solid fa-check bg-primary text-lg text-white px-2 py-1 rounded"></i>
                </button>
              </div>
            </div>

            <div className="mb-3 flex justify-between items-center gap-2">
              <label
                for="base-input"
                className="block text-base font-medium text-gray-600 dark:text-white"
              >
                E-mail:
              </label>
              <input
                disabled={true}
                value={data?.email}
                type="text"
                id="base-input"
                className="text-gray-900 text-base block w-[80%] py-2.5 px-2 border-none bg-gray-50"
              />
            </div>
            <div className="mb-3 flex justify-between items-center gap-2">
              <label
                for="base-input"
                className="block text-base font-medium text-gray-600 dark:text-white"
              >
                Organization:
              </label>
              <input
                disabled={true}
                value={data?.organization?.name}
                type="text"
                id="base-input"
                className="text-gray-900 text-base block w-[80%] py-2.5 px-2 border-none bg-gray-50"
              />
            </div>
            <div className="mb-3 flex gap-2">
              <label
                for="base-input"
                className="block text-base font-medium text-gray-600 dark:text-white"
              >
                Collection:
              </label>
              <div className="flex ml-7 items-center gap-1 flex-wrap">
                {data.collections.map((col) => (
                  <span className="text-xs font-semibold inline-block py-1 px-2 rounded text-primary bg-indigo-100  last:mr-0 mr-1">
                    {col.name}
                  </span>
                ))}
              </div>
            </div>
            <div className="mb-3 flex items-center justify-between gap-2">
              <label
                for="base-input"
                className="block text-base font-medium dark:text-white text-gray-600"
              >
                Member Since:
              </label>
              <input
                disabled={true}
                value={moment
                  .utc(data?.memberSince)
                  .format("dddd, MMMM Do YYYY")}
                type="text"
                id="base-input"
                className="text-gray-900 text-base block w-[80%] py-2.5 px-2 border-none bg-gray-50"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
